module.exports = __webpack_public_path__ + "img/Lato-Regular.aec1dd9c.svg";